import type { ApiEnvelope } from '../types';
import { EnterHttpError } from './errors';

/** Code API 历史上使用过的成功业务码集合。 */
export function isSuccessEnvelopeCode(code: unknown): boolean {
    return code === 0 || code === 200 || code === 'success';
}

/** 仅判断响应形状，不判断业务码是否成功。 */
export function isApiEnvelope<T = unknown>(input: unknown): input is ApiEnvelope<T> {
    if (!input || typeof input !== 'object') {
        return false;
    }

    return 'code' in input && 'message' in input;
}

/** 对明确要求“成功才返回”的领域接口校验业务信封并原样返回。 */
export function assertSuccessfulEnvelope<T>(input: ApiEnvelope<T>): ApiEnvelope<T> {
    if (!isSuccessEnvelopeCode(input.code)) {
        throw new EnterHttpError({
            message: input.message || 'Request failed',
            detail: input.detail,
            responseBody: input,
        });
    }

    return input;
}
